import { render, staticRenderFns } from "./learningCentreEdit.vue?vue&type=template&id=0a161a94&scoped=true&"
import script from "./learningCentreEdit.vue?vue&type=script&lang=js&"
export * from "./learningCentreEdit.vue?vue&type=script&lang=js&"
import style0 from "./learningCentreEdit.vue?vue&type=style&index=0&id=0a161a94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a161a94",
  null
  
)

export default component.exports